import type { ReactNode } from 'react';

/**
 * 교육 메인·카테고리 탭의 섹션 머리말.
 * 2026-10-10: 목업('메뉴바 및 교육 메인')에 맞춰 가운데 아이콘+제목에서
 * "작은 주황 문구(eyebrow) + 왼쪽 정렬 큰 제목" 형태로 통일.
 */

interface SectionHeadingProps {
  /** 제목 위 작은 주황 문구 */
  eyebrow: string;
  title: string;
  /** 제목 옆에 붙는 개수 표기 */
  count?: number;
  /**
   * 제목 굵기 — 목업 기준으로 '전체 교육 과정'류는 700(bold),
   * '접수 중인 인기 수업을 만나보세요'는 800(extrabold)이다.
   */
  titleWeight?: 'bold' | 'extrabold';
  /** 우측 영역 — 텍스트 링크(인기 수업) 또는 검색 카드(전체 교육 과정) */
  right?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  count,
  titleWeight = 'bold',
  right,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-4">
      <div className="flex flex-col items-start gap-1 shrink-0">
        <p className="text-[0.72rem] font-extrabold tracking-[0.13em] text-accent">{eyebrow}</p>
        <h2
          className={`flex items-baseline gap-2 text-[clamp(1.65rem,2.2vw,2.25rem)] tracking-[-0.035em] text-gray-900 leading-tight ${
            titleWeight === 'extrabold' ? 'font-extrabold' : 'font-bold'
          }`}
        >
          {title}
          {count !== undefined && (
            <span className="text-base font-normal tracking-normal text-gray-400">{count}개</span>
          )}
        </h2>
      </div>
      {right}
    </div>
  );
}
